import {
  IConfigInitialRules,
  IGetMatrixDownloadURL,
  IWebhookInfo,
  TContractOwner,
} from "../interfaces/configuration";
import { GET, PATCH, POST } from "../utils/constants";
import { fetchData } from "../utils/dataProvider";

export const patchContractOwner = (contractOwner: TContractOwner) =>
  fetchData({
    url: "/marketplaces/business_model",
    method: PATCH,
    body: { contractOwner },
  });

export const patchRules = (rules: IConfigInitialRules) =>
  fetchData({
    url: "/marketplaces/rules",
    method: PATCH,
    body: { rules },
  });

export const updateWebhookInfo = ({
  enabled,
  webhookUrl,
  authentication,
}: IWebhookInfo) =>
  fetchData({
    url: "/clients/webhook",
    method: PATCH,
    body: { enabled, url: webhookUrl, authentication_value: authentication },
  });

export const getMatrixDownloadURL = ({
  marketplaceId,
  matrixId,
  getError = false,
}: IGetMatrixDownloadURL) =>
  fetchData({
    url: `/matrices/${matrixId}?marketplaceId=${marketplaceId}&getError=${getError.toString()}`,
    method: GET,
  });

export const updatePostmarkSettings = ({ postmarkApiKey, postmarkEmail }: Record<string, string>) => {
  return fetchData({
    url: "/clients/updatePostmarkSettings",
    method: POST,
    body: { postmarkApiKey, postmarkEmail }
  });
};

